import React from 'react';
import PropTypes from 'prop-types';

import { Col, Row } from 'components/grid';

import { Title, Description } from './styles';

const PageTitleAndDescription = ({ title, description }) => (
  <Row>
    <Col>
      <Title>{title}</Title>
    </Col>
    <Col>
      {description && <Description>{description}</Description>}
    </Col>
  </Row>
);

PageTitleAndDescription.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};

PageTitleAndDescription.defaultProps = {
  description: null,
};

export default PageTitleAndDescription;
